import styled from 'styled-components'
import {DisabledButton} from './disabled-button.styled'

export const LargestDisabledButton = styled(DisabledButton)`
    width: 50px;
`
